import _ from "lodash";
import config from "@/config";
import { regions } from "@/lists";
import { SUBSCRIPTION_COUNTRIES } from "@/common/const";
import { mapGetters, mapActions } from "vuex";

const APP_ENV = process.env.VUE_APP_ENV;
const volunteerCountries = _.flatMap(regions, (region) =>
  _.filter(region.countries, { isVolunteer: true })
);
const allCountries = _.flatMap(regions, (region) =>
  _.map(region.countries, (country) => country)
);
function getCountryLinks(countryCode, languageCode) {
  const country = _.find(allCountries, { code: countryCode });
  return _.find(country?.languages, { code: languageCode });
}

export default {
  computed: {
    ...mapGetters([
      "isAuthorized",
      "userData",
      "subscriptionStatus",
      "headerLinks",
    ]),
    userCountry() {
      return this.userData?.spartan_country_code?.toUpperCase();
    },
    showSubscriptionLink() {
      let { country } = this.$route.query;

      if (
        !this.isAuthorized &&
        SUBSCRIPTION_COUNTRIES.includes(country?.toUpperCase())
      )
        return true;

      if (
        this.isAuthorized &&
        !this.subscriptionStatus &&
        SUBSCRIPTION_COUNTRIES.includes(this.userCountry)
      )
        return true;

      return false;
    },
    showTropaionLink() {
      return config.showTropaion;
    },
    showVolunteerView() {
      let countries = _.map(volunteerCountries, (vol) => vol.code);
      return countries.includes(this.userCountry);
    },
    showCodesView() {
      const countries = ["US", "GB", "CA", "FR", "ES", "NL", "IT", "DE", "FI"];
      return countries.includes(this.userCountry);
    },
    volunteerLink() {
      let country = _.find(volunteerCountries, { code: this.userCountry });
      if (!country) return;

      let countryLinks = _.find(country.languages, {
        code: this.userData?.language,
      });
      if (!countryLinks) return;
      return `${countryLinks.homeUrl}/about/volunteers`;
    },
    usLinks() {
      return getCountryLinks("US", "en");
    },
    countryLinks() {
      let country = getCountryLinks(this.userCountry, this.userData?.language);
      if (!country) return this.usLinks;

      return {
        ...country,
        termsUrl:
          country.termsUrl || `${country.homeUrl}/about/terms-and-conditions`,
        privacyPolicyUrl:
          country.privacyPolicyUrl || `${country.homeUrl}/about/privacy-policy`,
        subscriptionUrl: `${country.homeUrl}/pages/spartan-edge-membership`,
      };
    },
    shopLinks() {
      return {
        cart: `${config.shopUrl}/cart`,
        search: `${config.shopUrl}/search`,
        orders: `${config.shopUrl}/account`,
      };
    },
  },
  methods: {
    ...mapActions(["logOut"]),
    async userSignOut() {
      await this.logOut();
      console.log("userSignOut", APP_ENV);
      /* Keep old behavior in case it'll be needed in the future
      if (APP_ENV === "local") return this.$router.push({ name: "formLogin" });
      window.location = `${config.shopUrl}/account/logout`;
      */
      if (APP_ENV === "local") {
        return this.$router.push({ name: "formLogin" });
      } else if (APP_ENV === "staging") {
        window.location = `https://contentful-pet-staging.eks.spartan.com/`;
      } else {
        window.location = `https://spartan.com`;
      }
    },
  },
  mounted() {},
};
